<!-- left sidebar start -->
<div id="divForAdmin" class="sidenav">
    <a href="javascript:;" id="menucollo" class="menuCollapser" (click)="toggleClass()">
        <span id="SideNavCollapser" class="fa fa-bars"></span>
        <p id="menuparContainer">
            <span class="menuClass" i18n="@@Menu">Menu</span>
        </p>
    </a>
    <div id="sideNavContent">
        <div id="menuContent">
            <a routerLink='/dashboard' id="Dashboard" class="menuclass" dataName="Dashboard"
                routerLinkActive="activeMenu">
                <i class="nav-home"></i>
                <span i18n="@@Dashboard">Dashboard</span>
            </a>

            <a routerLink='/prospect' id="Prospects" class="menuclass" dataName="Prospects"
                routerLinkActive="activeMenu">
                <i class="nav-prospect"></i>
                <span i18n="@@Prospects">Prospects</span>
            </a>

            <a routerLink='/customer' id="Customer" class="menuclass" dataName="Customers"
                routerLinkActive="activeMenu">
                <i class="nav-customer"></i>
                <span i18n="@@Customer">Customers</span>
            </a>

            <ng-container *ngIf="!isCallcenterUser">
                <a routerLink='/facimer' id="Merchandise" class="menuclass" dataName="Merchandise"
                    routerLinkActive="activeMenu">
                    <i class="nav-merchandise"></i>
                    <span i18n="@@Merchandise">Merchandise</span>
                </a>
            </ng-container>

            <a routerLink='/layouts' id="Layouts" class="menuclass" dataName="Layouts" routerLinkActive="activeMenu">
                <i class="nav-layout"></i>
                <span i18n="@@Layouts">Layouts</span>
            </a>

            <a routerLink='/report' class="menuclass" id="Reports" dataName="Reports" routerLinkActive="activeMenu">
                <i class="nav-report"></i>
                <span i18n="@@Reports">Reports</span>
            </a>

            <a routerLink='/facilityAdmin' class="menuclass" id="Admin" dataName="Batch Process"
                routerLinkActive="activeMenu">
                <i class="nav-settings"></i>
                <span i18n="@@Admin">Batch Admin</span>
            </a>

            <a routerLink='/openClose' class="menuclass" id="Open/Close" dataName="Open/Close Store"
                routerLinkActive="activeMenu">
                <i class="nav-dayend"></i>
                <span i18n="@@openClose">Open / Close Store</span>
            </a>

            <a class="menuclass" id="open-app-btn" dataName="Ringcentral-Widget"
                *ngIf="this.phoneSystem && this.phoneSystem == 466" (click)="openRingCentralWidget()">
                <i class="nav-ringcentral"></i>
                <span>Ringcentral Widget</span>
            </a>
        </div>
    </div>
    <div class="lft_fade"></div>
</div>
<!-- left sidebar end -->